import { getEnvironmentVariable } from "src/utils/environment";

export function getFullJid(xmppLogin) {
  const xmppNode = xmppLogin + "@";
  const xmppDomain = getEnvironmentVariable("XMPP_DOMAIN");
  const xmppResource = "/" + getEnvironmentVariable("XMPP_RESOURCE");
  return xmppNode + xmppDomain + xmppResource;
}

export function addDomainTo(xmppLogin) {
  const xmppNode = xmppLogin + "@";
  const xmppDomain = getEnvironmentVariable("XMPP_DOMAIN");
  return xmppNode + xmppDomain;
}
